import { createAction, props } from '@ngrx/store';

export const setOverviewPlayed = createAction('[Oral Communication] Set Overview Played',props<{payload:boolean}>());